/** Thai strings for Season 1 ("The Whole School"): monsters, chapters, items and quests. */
export const SEASON1: Record<string, string> = {
  "Crayon Wolf": "หมาป่าสีเทียน",
  "Howls in all 64 colours. Leaves wax on everything.": "หอนได้ครบ 64 สี ไปไหนมีคราบเทียนติดทุกที่",
  "Paint Splat": "สีโปสเตอร์หก",
  "A puddle of poster paint that never dries.": "กองสีโปสเตอร์ที่ไม่เคยแห้งสักที",
  "Scissor Mantis": "ตั๊กแตนกรรไกร",
  "Two pairs of safety scissors and zero safety.": "มีกรรไกรปลายมนสองคู่ แต่ไม่ปลอดภัยเลยสักนิด",
  "Easel Titan": "ยักษ์ขาตั้งวาดรูป",
  "A wooden easel holding the worst painting ever drawn. Boss of the Art Room.": "ขาตั้งไม้ที่ถือภาพวาดแย่ที่สุดในโลก บอสห้องศิลปะ",
  "Bookworm Serpent": "งูหนอนหนังสือ",
  "Eats whole chapters and burps footnotes.": "กินหนังสือทีละบท แล้วเรอออกมาเป็นเชิงอรรถ",
  "Bookmark Bat": "ค้างคาวที่คั่นหนังสือ",
  "Folds itself flat and hides between the pages.": "พับตัวแบนแล้วซ่อนอยู่ระหว่างหน้ากระดาษ",
  "Dusty Tome": "สารานุกรมฝุ่นเขรอะ",
  "An encyclopedia nobody has opened for years. Heavy and cranky.": "สารานุกรมที่ไม่มีใครเปิดมาหลายปี หนักและขี้หงุดหงิด",
  "Shush Owl": "นกฮูกจุ๊ๆ",
  "Guardian of the library. Every hit you land earns a loud SHHH. Boss of the Library.": "ผู้พิทักษ์ห้องสมุด ตีโดนทีไรโดนจุ๊ๆ ทุกที บอสห้องสมุด",
  "Beaker Blob": "บีกเกอร์บลอบ",
  "Bubbles over when it gets angry. It gets angry a lot.": "โกรธทีไรฟองล้นทุกที และมันโกรธบ่อยมาก",
  "Magnet Mole": "ตุ่นแม่เหล็ก",
  "Pulls every paperclip in the room toward it.": "ดูดคลิปหนีบกระดาษทั้งห้องเข้าหาตัว",
  "Volcano Toad": "คางคกภูเขาไฟ",
  "A baking-soda science project that erupts on purpose.": "โครงงานวิทย์ภูเขาไฟที่ตั้งใจระเบิดใส่คุณ",
  "Calculator Bot": "หุ่นยนต์เครื่องคิดเลข",
  "Solves you for X. X is always \"lose\". Boss of the Science Lab.": "แก้สมการหาค่า X ได้ทุกครั้ง และ X คือ \"แพ้\" เสมอ บอสห้องวิทย์",
  "Dodgeball Ogre": "ยักษ์ลูกบอลหลบ",
  "Throws hard. Throws even harder when it misses.": "ขว้างแรง และถ้าขว้างพลาดจะยิ่งขว้างแรงกว่าเดิม",
  "Jump-Rope Snake": "งูเชือกกระโดด",
  "Skips, trips and whips.": "กระโดด สะดุด แล้วฟาด",
  "Whistle Hawk": "เหยี่ยวนกหวีด",
  "Its whistle stops every game. Even yours.": "เป่านกหวีดทีไรเกมหยุดหมด รวมถึงเกมของคุณด้วย",
  "Sneaker Kaiju": "ไคจูรองเท้าผ้าใบ",
  "A giant lost gym shoe that stomps the whole field. Boss of the Gym.": "รองเท้ายิมยักษ์ที่หายไปแล้วกลับมาเหยียบทั้งสนาม บอสโรงยิม",
  "Meatball Golem": "โกเลมมีทบอล",
  "Mystery meat, mystery strength.": "เนื้ออะไรก็ไม่รู้ แรงเท่าไหร่ก็ไม่รู้",
  "Jelly Jiggler": "เยลลี่ดุ๊กดิ๊ก",
  "Wobbles out of the way of almost every hit.": "ส่ายหลบได้แทบทุกหมัด",
  "Milk Carton Knight": "อัศวินกล่องนม",
  "Expired, armoured and very sour.": "หมดอายุแล้ว ใส่เกราะ และเปรี้ยวมาก",
  "Mystery Meal Hydra": "ไฮดราอาหารปริศนา",
  "Three heads, three trays, one terrible lunch. Boss of the Cafeteria.": "สามหัว สามถาด อาหารกลางวันที่แย่ที่สุด บอสโรงอาหาร",
  "The Art Room": "ห้องศิลปะ",
  "Chapter 5": "บทที่ 5",
  "Paint is moving on its own and the scissors are snipping at shadows. Something in the Art Room is drawing back.": "สีเคลื่อนไหวได้เอง กรรไกรไล่ตัดเงา มีบางอย่างในห้องศิลปะกำลังวาดโต้ตอบกลับมา",
  "The Silent Library": "ห้องสมุดเงียบกริบ",
  "Chapter 6": "บทที่ 6",
  "Books are flying off the shelves and every page is whispering. Find out who woke the library up.": "หนังสือบินออกจากชั้น ทุกหน้ากระซิบกันเสียงดัง ไปหาว่าใครปลุกห้องสมุดขึ้นมา",
  "The Science Lab": "ห้องวิทยาศาสตร์",
  "Chapter 7": "บทที่ 7",
  "An experiment bubbled over and now the lab is alive. Put on your goggles.": "การทดลองล้นออกมาจนห้องแล็บมีชีวิต ใส่แว่นตานิรภัยให้พร้อม",
  "The Gym": "โรงยิม",
  "Chapter 8": "บทที่ 8",
  "The equipment cupboard burst open and the whole gym wants a rematch.": "ตู้อุปกรณ์กีฬาแตก แล้วทั้งโรงยิมก็อยากแข่งกับคุณอีกรอบ",
  "The Cafeteria": "โรงอาหาร",
  "Chapter 9": "บทที่ 9",
  "Today's lunch is fighting back. Clear the trays before the bell rings.": "อาหารกลางวันวันนี้สู้กลับ จัดการถาดอาหารให้หมดก่อนกริ่งดัง",
  "Sharpie Saber": "ดาบปากกาเคมี",
  "Permanent damage. Literally.": "ความเสียหายถาวร ตามตัวอักษรเลย",
  "Paintbrush Staff": "คทาพู่กัน",
  "Paints you a little healthier.": "ระบายให้คุณแข็งแรงขึ้นนิดหน่อย",
  "Protractor Axe": "ขวานไม้โปรแทรกเตอร์",
  "Cuts at exactly 45 degrees.": "ฟันได้ 45 องศาเป๊ะ",
  "Calculator Club": "กระบองเครื่องคิดเลข",
  "Adds up to a lot of damage.": "บวกรวมแล้วแรงมาก",
  "Cardigan Coat": "เสื้อคาร์ดิแกน",
  "Knitted by the librarian. Very cosy.": "บรรณารักษ์ถักให้ อุ่นสุดๆ",
  "Lab Coat": "เสื้อกาวน์แล็บ",
  "Stain-proof. Mostly.": "กันคราบได้ ส่วนใหญ่นะ",
  "Gym Jersey": "เสื้อทีมกีฬา",
  "Number 1, obviously.": "เบอร์ 1 อยู่แล้ว",
  "Lunch Tray Shield": "โล่ถาดอาหาร",
  "Survived a thousand lunches.": "รอดมาแล้วนับพันมื้อ",
  "Library Card": "บัตรห้องสมุด",
  "Never overdue.": "ไม่เคยคืนช้า",
  "Golden Whistle": "นกหวีดทองคำ",
  "Everyone stops and listens.": "เป่าแล้วทุกคนหยุดฟัง",
  "Science Fair Medal": "เหรียญงานวิทย์",
  "First place, volcano category.": "ที่หนึ่ง ประเภทภูเขาไฟ",
  "Lunch Money": "เงินค่าขนม",
  "Jingles in your pocket. Feels lucky.": "กรุ๊งกริ๊งในกระเป๋า รู้สึกโชคดี",
  "Art Critic": "นักวิจารณ์ศิลปะ",
  "Defeat every monster in the Art Room.": "ชนะมอนสเตอร์ทุกตัวในห้องศิลปะ",
  "Quiet Please": "กรุณาเงียบ",
  "Defeat every monster in the Silent Library.": "ชนะมอนสเตอร์ทุกตัวในห้องสมุดเงียบกริบ",
  "Mad Scientist": "นักวิทย์บ้าพลัง",
  "Defeat every monster in the Science Lab.": "ชนะมอนสเตอร์ทุกตัวในห้องวิทยาศาสตร์",
  "Most Valuable Player": "ผู้เล่นทรงคุณค่า",
  "Defeat every monster in the Gym.": "ชนะมอนสเตอร์ทุกตัวในโรงยิม",
  "The Whole School": "ทั้งโรงเรียน",
  "Defeat every monster in the school, cafeteria included.": "ชนะมอนสเตอร์ทุกตัวในโรงเรียน รวมโรงอาหารด้วย",
  "Big Kid": "โตแล้วนะ",
  "Reach level 15.": "เลเวลถึง 15",
  "Hall Monitor": "หัวหน้าห้อง",
  "Reach level 20.": "เลเวลถึง 20",
  "Senior": "รุ่นพี่",
  "Reach level 30.": "เลเวลถึง 30",
  "Paper Legend": "ตำนานกระดาษ",
  "Reach level 50.": "เลเวลถึง 50",
  "First Floors": "ชั้นแรกๆ",
  "Climb to floor 5 of the Homework Tower.": "ปีนหอการบ้านถึงชั้น 5",
  "Halfway Up": "ครึ่งทาง",
  "Climb to floor 10 of the Homework Tower.": "ปีนหอการบ้านถึงชั้น 10",
  "Tower Climber": "นักปีนหอ",
  "Climb to floor 25 of the Homework Tower.": "ปีนหอการบ้านถึงชั้น 25",
  "Top of the Tower": "ยอดหอคอย",
  "Climb to floor 50 of the Homework Tower.": "ปีนหอการบ้านถึงชั้น 50",
  "Hundred Wins": "ร้อยชัยชนะ",
  "Win 100 battles.": "ชนะ 100 ครั้ง",
  "Homework Tower": "หอการบ้าน",
  "Best: floor {n}": "สูงสุด: ชั้น {n}",
  "An endless climb. Every floor is a little tougher, every fifth floor is a boss.": "ปีนได้ไม่รู้จบ ทุกชั้นยากขึ้นนิดหน่อย และทุกๆ 5 ชั้นจะเจอบอส",
  "Floor {n}": "ชั้น {n}",
  "Climb!": "ปีนเลย!",
  "Next floor ({n})": "ชั้นถัดไป ({n})",
  "Feeling Lucky": "รู้สึกโชคดี",
  "Roll the lucky dice 10 times.": "ทอยลูกเต๋านำโชค 10 ครั้ง",
  "Dice Master": "เซียนลูกเต๋า",
  "Roll the lucky dice 100 times.": "ทอยลูกเต๋านำโชค 100 ครั้ง",
  "Board Game Night": "คืนเล่นเกมกระดาน",
  "Go all the way round the dice board.": "เดินครบรอบกระดานลูกเต๋า 1 รอบ",
  "Board Game Champion": "แชมป์เกมกระดาน",
  "Go round the dice board 10 times.": "เดินครบรอบกระดานลูกเต๋า 10 รอบ",
};
